<!-- 搜索时间组件 -->
<template>
  <div class="search-condition" style="margin-bottom: 16px">
    <div class="clear-float">
      <div
        style="
          display: flex;
          flex-wrap: wrap;
          align-content: center;
          margin-right: 90px;
        "
      >
        <div style="margin-right: 12px; display: flex; align-items: center">
          <div
            class="clear-float form-item"
            style="float: left; margin-right: 9px"
          >
            <div class="condition-label">{{ title }}：</div>
          </div>

          <!-- 按钮 -->
          <!-- 昨天 -->
          <div
            class="clear-float"
            style="float: left; margin-right: 8px"
            v-if="isShowOne"
          >
            <el-button
              plain
              @click="handleBtnChange(1)"
              :class="{ 'btn-current': actBtnIndex === 1 }"
              :style="{
                color: actBtnIndex === 1 ? changeColor : '',
                'border-color': actBtnIndex === 1 ? changeColor : '',
              }"
              :disabled="limit"
            >
              昨天
            </el-button>
          </div>
          <!-- 近7天 -->
          <div
            class="clear-float"
            style="float: left; margin-right: 8px"
            v-if="isShowSeven"
          >
            <el-button
              plain
              @click="handleBtnChange(7)"
              :class="{ 'btn-current': actBtnIndex === 7 }"
              :style="{
                color: actBtnIndex === 7 ? changeColor : '',
                'border-color': actBtnIndex === 7 ? changeColor : '',
              }"
              :disabled="limit"
              >近7天</el-button
            >
          </div>
          <!-- 近15天 -->
          <div
            class="clear-float"
            style="float: left; margin-right: 8px"
            v-if="isShowFifteen"
          >
            <el-button
              plain
              @click="handleBtnChange(15)"
              :class="{ 'btn-current': actBtnIndex === 15 }"
              :style="{
                color: actBtnIndex === 15 ? changeColor : '',
                'border-color': actBtnIndex === 15 ? changeColor : '',
              }"
              :disabled="limit"
              >近15天</el-button
            >
          </div>
          <!-- 近30天 -->
          <div
            class="clear-float"
            style="float: left; margin-right: 8px"
            v-if="isShowThirty"
          >
            <el-button
              plain
              @click="handleBtnChange(30)"
              :class="{ 'btn-current': actBtnIndex === 30 }"
              :style="{
                color: actBtnIndex === 30 ? changeColor : '',
                'border-color': actBtnIndex === 30 ? changeColor : '',
              }"
              :disabled="limit"
              >近30天</el-button
            >
          </div>

          <!-- 日期选择器 -->
          <div
            class="clear-float form-item"
            style="float: left; margin-right: 9px"
          >
            <div class="condition-content" style="width: 330px">
              <el-date-picker
                prefix-icon="testDate"
                type="date"
                value-format="yyyy-MM-dd"
                v-model="postForm.sendStartTime"
                placeholder="选择日期时间"
                class="width_150"
                size="small"
                :picker-options="pickerOptions0"
                :clearable="false"
                @change="handleChange"
              ></el-date-picker>
              <span class="to_text">{{ toText }}</span>
              <el-date-picker
                type="date"
                value-format="yyyy-MM-dd"
                v-model="postForm.sendEndTime"
                :picker-options="pickerOptions1"
                prefix-icon="testDate"
                placeholder="选择日期时间"
                class="width_150"
                size="small"
                :clearable="false"
                @change="handleChange"
              ></el-date-picker>
            </div>
          </div>

          <!-- 插槽 -->
          <div style="margin-right: 12px; margin-bottom: 16px">
            <slot name="slotBox"></slot>
          </div>

          <!-- 查询\重置按钮 -->
          <div
            style="display: flex; align-items: center; justify-content: center"
          >
            <el-button
              size="small"
              class="search"
              @click="handleSearch"
              :disabled="limit"
            >
              <i
                class="el-icon-search"
                style="display: inline-block; width: 14px; height: 12px"
              ></i>
              查询
            </el-button>
            <el-button
              class="reset"
              :disabled="limit"
              @click="handleReset"
              v-if="showReset"
            >
              重置
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "searchCondition",
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  props: {
    title: {
      type: String,
      default: "付款时间",
    },
    // 初始默认时间
    currenttime: {
      type: Array,
    },
    // 表示当前活动的按钮
    activeInd: {
      type: Number,
      default: 1,
    },
    // 表示默认当前活动按钮
    defaultActIndex: {
      type: Number,
      default: 1,
    },
    // 控制按钮可否点击
    limit: {
      type: null,
    },
    // 是否显示昨天
    isShowOne: {
      type: Boolean,
      default: true,
    },
    // 是否显示近七天
    isShowSeven: {
      type: Boolean,
      default: true,
    },
    // 是否显示近十五天
    isShowFifteen: {
      type: Boolean,
      default: false,
    },
    // 是否显示近三十天
    isShowThirty: {
      type: Boolean,
      default: true,
    },
    // 是否显示重置按钮
    showReset: {
      type: Boolean,
      default: false,
    },
    // 中间链接符号
    toText: {
      type: String,
      default: "-",
    },
    // 时间跨度
    dayTime: {
      type: Number,
      default: 365,
    },
  },
  data() {
    return {
      // 当前活跃按钮
      actBtnIndex: 1,
      postForm: {
        sendStartTime: "",
        sendEndTime: "",
      },
      pickerMinDate: "",
      pickerOptions0: {
        disabledDate: (time) => {
          if (!this.postForm.sendEndTime) {
            return time.getTime() > Date.now() - 8.64e7;
          } else {
            let endTime = new Date(this.postForm.sendEndTime).getTime();
            // 最小选择时间   (时间跨度不能大于一年时间)
            // let minTime = endTime - Number(this.dayTime) * 24 * 3600 * 1000;
            return time.getTime() > endTime;
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          if (!this.postForm.sendStartTime) {
            return time.getTime() > Date.now() - 8.64e7;
          } else {
            let startTime = new Date(this.postForm.sendStartTime).getTime();
            // 最大选择时间  （时间跨度不能大于一年）
            let maxTime = startTime + Number(this.dayTime) * 24 * 3600 * 1000;
            return (
              time.getTime() < startTime ||
              time.getTime() > Date.now() - 8.64e7 ||
              time.getTime() > maxTime - 8.64e7
            );
          }
        },
      },
    };
  },
  watch: {
    currenttime(val) {
      this.mytime = val;
      this.postForm.sendStartTime = val[0] || "";
      this.postForm.sendEndTime = val[1] || "";
    },
    activeInd: {
      immediate: true,
      deep: true,
      handler(val) {
        this.actBtnIndex = val;
      },
    },
  },
  mounted() {
    this.mytime = this.currenttime;
    this.postForm.sendStartTime = this.currenttime[0] || "";
    this.postForm.sendEndTime = this.currenttime[1] || "";
    this.actBtnIndex = this.defaultActIndex;
  },
  methods: {
    // 监听日期按钮改变
    handleBtnChange(index) {
      this.actBtnIndex = index;
      this.$emit("changeTime", index);
    },
    // 监听查询
    handleSearch() {
      this.$emit("search", [
        this.postForm.sendStartTime,
        this.postForm.sendEndTime,
      ]);
    },
    // 监听重置
    handleReset() {
      this.actBtnIndex = this.defaultActIndex;
      this.$emit("changeTime", this.actBtnIndex, true);
    },
    // 监听日期自定义
    handleChange() {
      // console.log("handleChange");
      if (this.postForm.sendStartTime && this.postForm.sendEndTime) {
        const differenceInDays = Math.abs(
          (new Date(this.postForm.sendStartTime).getTime() -
            new Date(this.postForm.sendEndTime).getTime()) /
            (1000 * 60 * 60 * 24)
        );
        // console.log(differenceInDays);
        // 如果超过90天，清空结束日期
        if (differenceInDays > this.dayTime) {
          this.postForm.sendEndTime = null;
          this.$message.warning(`日期间隔不能超过${this.dayTime}天`);
        }
      }
      // 如果自定义事件，活动按钮设为0
      this.actBtnIndex = 0;
      this.$emit("setTime", [
        this.postForm.sendStartTime,
        this.postForm.sendEndTime,
      ]);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-item {
  display: flex;
  align-items: center;
}
.condition-label {
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  line-height: 32px;
  color: rgba(102, 102, 102, 1);
  text-align: right;
  width: 76px;
}
.condition-content {
  float: left;
  .el-date-editor__trigger {
    display: none !important;
  }
}
.width_150 {
  width: 150px !important;
}
.to_text {
  display: inline-block;
  vertical-align: middle;
  margin: 0 7px;
}
.search,
.reset {
  width: 98px !important;
  font-size: 14px;
  height: 32px !important;
  transition: all 0.2s;
}
.search {
  color: #fe4d45;
  border: 1px solid #fe4d45;
  background-color: #fff;
  &:hover {
    color: #fff;
    border: 1px solid #fff;
    background-color: #fe4d45;
  }
}
.reset {
  color: #666666;
  border: 1px solid #dddddd;
  background-color: #fff;
  &:hover {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}
</style>